import { useEffect } from "react";
import Hero from "@/components/Hero";
import Generator from "@/components/Generator";
import HowItWorks from "@/components/HowItWorks";
import UseCases from "@/components/UseCases";
import Benefits from "@/components/Benefits";
import ContentSection from "@/components/ContentSection";
import TextContentBoost from "@/components/TextContentBoost";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";

const Index = () => {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebApplication",
          "@id": "https://namebiolab.lovable.app/#webapp",
          "name": "NameBioLab - AI Username & Bio Generator",
          "url": "https://namebiolab.lovable.app/",
          "description": "Free AI-powered username and bio generator for Instagram, TikTok, YouTube, Twitter, and all social media platforms. Create unique, creative usernames and engaging bios instantly.",
          "applicationCategory": "UtilitiesApplication",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          },
          "operatingSystem": "Any",
          "browserRequirements": "Requires JavaScript. Requires HTML5.",
          "permissions": "No special permissions required"
        },
        {
          "@type": "Organization",
          "@id": "https://namebiolab.lovable.app/#organization",
          "name": "NameBioLab",
          "url": "https://namebiolab.lovable.app/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://namebiolab.lovable.app/favicon.ico"
          },
          "sameAs": []
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://namebiolab.lovable.app/#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://namebiolab.lovable.app/"
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main className="min-h-screen bg-background">
      <Hero />
      <Generator />
      <HowItWorks />
      <UseCases />
      <Benefits />
      <ContentSection />
      <TextContentBoost />
      <FAQ />
      <Footer />
      <CookieConsent />
    </main>
  );
};

export default Index;
